import * as React from "react";
import { Button } from "antd";
import { IModule } from "src/@types/ImpiricaPlatformApi";
import { CognitiveText } from "../forms/ProductType";

interface IProps {
	careTestResultId?: number;
	dataLocked: boolean;
	canEditCare: boolean;
	getVitalsSummary: (careTestResultId: number | undefined) => void;
	modules?: IModule[];
	productType?: ProductType;
}

export const VitalsSummaryButton = (props: IProps) => {
	if (
		props.careTestResultId &&
		props.careTestResultId > 0 &&
		props.canEditCare
	) {
		return (
			<Button
				className="btn-primary"
				onClick={() => {
					props.getVitalsSummary(props.careTestResultId);
				}}
				disabled={props.dataLocked}
			>
				Edit {CognitiveText(props.productType)} Summary
			</Button>
		);
	} else {
		return <></>;
	}
};
